import { render, staticRenderFns } from "./Movments.vue?vue&type=template&id=2372947b&"
import script from "./Movments.vue?vue&type=script&lang=js&"
export * from "./Movments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports